export enum EnumWaterBottleDelivery {
    BONBONNES_DELIVERY_CENTRAL_STOCK = 'BONBONNES_DELIVERY_CENTRAL_STOCK',
    BONBONNES_DELIVERY_FONTAINE = 'BONBONNES_DELIVERY_FONTAINE'
}

